import * as React from 'react';
const CarenzaDiVitamineIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1{fill:${secondaryColor || '#ffcf38'}}`}</style>
    </defs>
    <path d="M78.75 140.3c-11.7 0-21.23-9.52-21.23-21.23s9.52-21.23 21.23-21.23 21.23 9.52 21.23 21.23-9.52 21.23-21.23 21.23m0-38.54c-9.55 0-17.32 7.77-17.32 17.32s7.77 17.32 17.32 17.32 17.32-7.77 17.32-17.32-7.77-17.32-17.32-17.32" />
    <path
      d="M81.27 123.89h-5.08l-.89 2.87h-3.96l5.63-15.36h3.48l5.68 15.36h-3.98l-.9-2.87Zm-4.19-2.86h3.3l-1.66-5.33-1.65 5.33ZM94.61 87.13c-.06 1.25-.4 2.36-1.01 3.32s-1.49 1.7-2.6 2.23c-1.12.53-2.39.79-3.82.79-2.36 0-4.23-.77-5.59-2.31s-2.04-3.72-2.04-6.53v-.89c0-1.76.31-3.31.92-4.63s1.5-2.34 2.65-3.06 2.49-1.08 4-1.08c2.18 0 3.94.57 5.26 1.72s2.08 2.73 2.26 4.75h-4.33c-.03-1.1-.31-1.88-.83-2.36q-.78-.72-2.37-.72c-1.59 0-1.87.4-2.37 1.21s-.77 2.1-.79 3.87v1.27c0 1.92.24 3.29.72 4.12s1.31 1.24 2.49 1.24c1 0 1.76-.23 2.29-.7s.81-1.22.84-2.24h4.31Z"
      className="prefix__cls-1"
    />
    <path d="M132.7 114.75c-1.08 0-1.96-.88-1.96-1.96 0-8.7-7.08-15.78-15.78-15.78-1.08 0-1.96-.88-1.96-1.96s.88-1.96 1.96-1.96c10.86 0 19.69 8.83 19.69 19.69 0 1.08-.88 1.96-1.96 1.96Z" />
    <path d="M114.96 140.3c-5.67 0-11.12-1.71-15.74-4.95-.89-.62-1.1-1.84-.48-2.72.62-.89 1.84-1.1 2.72-.48 3.97 2.78 8.64 4.24 13.5 4.24 13.01 0 23.6-10.59 23.6-23.6s-10.59-23.6-23.6-23.6c-7.62 0-14.81 3.71-19.24 9.93-.63.88-1.85 1.09-2.73.46a1.965 1.965 0 0 1-.46-2.73 27.58 27.58 0 0 1 22.43-11.57c15.17 0 27.51 12.34 27.51 27.51s-12.34 27.51-27.51 27.51" />
    <path
      d="M120.27 107.97v-2.86h-10.61v15.36h10.58v-2.85h-6.88v-3.67h5.83v-2.75h-5.83v-3.24h6.9Z"
      className="prefix__cls-1"
    />
    <path d="M67.54 97.45c-.68 0-1.33-.35-1.7-.98a24.53 24.53 0 0 1-3.27-12.25c0-13.53 11-24.53 24.53-24.53 5.91 0 11.62 2.13 16.08 6.01 4.41 3.84 7.32 9.12 8.18 14.87.16 1.07-.58 2.06-1.65 2.22s-2.06-.58-2.22-1.65c-1.49-10-10.26-17.55-20.39-17.55-11.37 0-20.62 9.25-20.62 20.62 0 3.62.95 7.18 2.75 10.29.54.94.22 2.13-.72 2.67-.31.18-.64.26-.98.26Z" />
  </svg>
);
export default CarenzaDiVitamineIcon;
